import { List } from 'antd';
import {
  CallIcon,
  GlobalIcon,
  InstagramOriginalIcon,
  LocationIcon,
  SmsIcon,
  TelegramCircleIcon,
  YoutubeIcon
} from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useInteractionHandler, UserInteraction } from 'modules/global';
import { IAllUniversities, UniversityTypes } from 'modules/universities';

import { YandexMap } from 'components';

interface IProps {
  university?: IAllUniversities;
}

const ContactSection: React.FC<IProps> = props => {
  const t = useTranslations();
  const { onInteractionClick } = useInteractionHandler(props?.university?.id);

  const getFullUrl = (url: string) =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;

  return (
    <div>
      <div className="flex items-center justify-center gap-2">
        {props?.university?.telegram && (
          <Link
            href={props?.university?.telegram}
            target="_blank"
            className="mb-4 flex h-9 w-9 items-center justify-center rounded-lg bg-gray-100"
            aria-label="Universitetning Telegram sahifasi uchun havola"
          >
            <TelegramCircleIcon />
          </Link>
        )}
        {props?.university?.instagram && (
          <Link
            href={props?.university?.instagram}
            target="_blank"
            className="mb-4 flex h-9 w-9 items-center justify-center rounded-lg bg-gray-100"
            aria-label="Universitetning Instagram sahifasi uchun havola"
          >
            <InstagramOriginalIcon />
          </Link>
        )}
        {props?.university?.youtube && (
          <Link
            href={props?.university?.youtube}
            target="_blank"
            className="mb-4 flex h-9 w-9 items-center justify-center rounded-lg bg-gray-100 text-red-500"
            aria-label="Universitetning Youtube sahifasi uchun havola"
          >
            <YoutubeIcon />
          </Link>
        )}
      </div>

      <div>
        <List itemLayout="horizontal">
          <ul>
            {props?.university?.phone && (
              <List.Item className="!font-medium">
                <Link
                  href={`tel:${props?.university?.phone?.replace(/\s|-/g, '')}`}
                  onClick={onInteractionClick(UserInteraction.PHONE_CLICK)}
                  target="_blank"
                  className="!text-green-500"
                >
                  <List.Item.Meta avatar={<CallIcon />} title={props?.university?.phone} />
                </Link>
              </List.Item>
            )}
            {props?.university?.email && (
              <List.Item className="!font-medium">
                <Link href={`mailto:${props?.university?.email}`} target="_blank" className="w-full text-green-500">
                  <List.Item.Meta avatar={<SmsIcon />} title={props?.university?.email} />
                </Link>
              </List.Item>
            )}
            {props?.university?.site && (
              <List.Item onClick={onInteractionClick(UserInteraction.SITE_CLICK)} className="!font-medium">
                <Link href={getFullUrl(props?.university?.site)} target="_blank" className="w-full !text-green-500">
                  <List.Item.Meta avatar={<GlobalIcon />} title={props?.university?.site} />
                </Link>
              </List.Item>
            )}
            {props?.university?.address && props?.university?.map && (
              <List.Item className="!font-medium">
                <Link className="w-full !text-green-500" href={`${props?.university?.map}`} target="_blank">
                  <List.Item.Meta avatar={<LocationIcon />} title={props?.university?.address} />
                </Link>
              </List.Item>
            )}
          </ul>
        </List>

        {props?.university?.type === UniversityTypes.PRIVATE && (
          <Link
            href={getFullUrl(props?.university?.site)}
            target="_blank"
            aria-label="Universitet web sahifasiga o'tish uchun havola"
            onClick={onInteractionClick(UserInteraction.SITE_CLICK)}
            className="!mt-3 flex w-full items-center justify-center gap-2 !rounded-lg !bg-gray-800 !py-1.5 text-sm !text-white hover:!bg-gray-700"
          >
            <GlobalIcon />
            {t('web_saytga_otish')}
          </Link>
        )}

        {props?.university?.type === UniversityTypes.PUBLIC &&
          props?.university?.longitude &&
          props?.university?.latitude && (
            <YandexMap
              latitude={props.university?.latitude}
              longitude={props.university?.longitude}
              logoUrl={props.university?.logo}
            />
          )}
      </div>
    </div>
  );
};

export default ContactSection;
